module.exports = __webpack_public_path__ + "static/img/bronxbrewery_logo.6b71b38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bronxbrewery_logo.png
// module id = 290
// module chunks = 1